export default __webpack_public_path__ + "static/media/castledown-heavy.b78cce5c.eot";